import { render, staticRenderFns } from "./PacienteLegadoManual.vue?vue&type=template&id=7b38de12&"
import script from "./PacienteLegadoManual.vue?vue&type=script&lang=js&"
export * from "./PacienteLegadoManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports